<template>
    <div>
      <!-- Company Admin view: tabbed layout with company name header -->
      <template v-if="isCompanyAdmin">
        <CompanyAdminUsers :company="currentUser.company" />
      </template>

      <!-- Superuser view: unchanged original layout -->
      <template v-else>
        <div class="py-4">
          <TableUsers />
          <ModalAssignCompany />
          <ModalCompanyRole />
          <ModalUserName />
          <UserTypeModal />
          <AddUserModal
            @update:show="(value) => (showAddUserModal = value)"
            :show="showAddUserModal"
            :create-superuser="currentUser.is_superuser"
            :for-company="null"
          />
          <UserReportsModal
            @update:show="(value) => (showUserReportsModal = value)"
            :show="showUserReportsModal"
            :user-id="selectedUserId"
          />
        </div>
      </template>
    </div>

</template>

<script>
import Vue from 'vue'
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onUnmounted
} from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { useAuth } from '@composables/auth'
import Members from '@services/Members'
import { UserTypeModal } from '@components/user'

import TableUsers from '@components/TableUsers'
import ModalAssignCompany from '@components/ModalAssignCompany'
import ModalCompanyRole from '@components/ModalCompanyRole'
import ModalUserName from '@components/ModalUserName'
import AddUserModal from '@components/AddUserModal'
import UserReportsModal from '@components/UserReportsModal'
import CompanyAdminUsers from '@components/CompanyAdminUsers'

export default defineComponent({
  name: 'Users',
  title: 'Users',
  components: {
    UserTypeModal,
    TableUsers,
    ModalAssignCompany,
    ModalUserName,
    ModalCompanyRole,
    AddUserModal,
    UserReportsModal,
    CompanyAdminUsers
  },
  setup() {
    const { useMutations } = createVuexHelpers()

    const { READ_MEMBER } = useMutations(['READ_MEMBER'])

    const { currentUser } = useAuth()

    const showAddUserModal = ref(false)
    const showUserReportsModal = ref(false)
    const selectedUserId = ref(0)

    const isCompanyAdmin = computed(() => {
      return currentUser.value &&
        currentUser.value.type === 'Company' &&
        currentUser.value.company &&
        currentUser.value.company.role &&
        ['TPA', 'Underwriter'].includes(currentUser.value.company.role.role)
    })

    // Only wire up modal events for Superuser path
    // CompanyAdminUsers handles its own modal events
    onMounted(() => {
      if (!isCompanyAdmin.value) {
        Vue.prototype.$bus.trackEvent('toggle-modal', async (payload) => {
          if (['user-report-access'].includes(payload.key)) {
            const resp = await Members.readMember(payload.id)
            const member = resp.data.data.data
            READ_MEMBER({ data: member })
          }

          if ('add-user' === payload.key) {
            showAddUserModal.value = payload.active
          } else if ('user-report-access' === payload.key) {
            showUserReportsModal.value = payload.active
            selectedUserId.value = payload.id
          }
        })
      }
    })

    onUnmounted(() => {
      Vue.prototype.$bus.destroyEvents()
    })

    return {
      currentUser,
      isCompanyAdmin,
      showAddUserModal,
      showUserReportsModal,
      selectedUserId
    }
  }
})
</script>